// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { SectionHeadersProps } from './utils/types.ts'
import SectionHeader from './SectionHeader.tsx'
import {
    // TOP_BUFFER,
    LINE_HEIGHT,
    SIDE_BUFFER,
    STAT_HEADER_GAP,
    TEAM_LOGO_SIZE,
} from './utils/constants.ts'
import { useDimensions } from './utils/responsive-dimensions.tsx'

function SectionHeaders(props: SectionHeadersProps) {
    const {
        numPlayers,
        groupedSelects,
        existingTypes,
        maxSliderWidth,
        showTeams,
    } = props

    const { TOP_BUFFER } = useDimensions()

    let statsSeen = 0

    const typeHeaders = existingTypes.map((type, i) => {
        const headersOffset = STAT_HEADER_GAP * i
        const statsOffset = statsSeen * LINE_HEIGHT
        const teamOffset = showTeams ? 0 : -TEAM_LOGO_SIZE

        const yOffset = headersOffset + statsOffset + teamOffset

        const header = (
            <g key={type} transform={`translate(0,${yOffset})`}>
                <SectionHeader
                    key={`${type}_section_header`}
                    type={type}
                    numPlayers={numPlayers}
                    maxSliderWidth={maxSliderWidth}
                />
            </g>
        )

        statsSeen += groupedSelects[type].length

        return header
    })

    return (
        <g transform={`translate(${SIDE_BUFFER},${TOP_BUFFER})`}>
            {typeHeaders}
        </g>
    )
}

export default SectionHeaders
